import { SailsTariffOverviewStorage } from 'Container/App/interface';
import { getInsuranceFromSails } from '@vfde-sails/storage';

/**
 * Get insurance from session storage
 */
export const getInsurance = (storage: SailsTariffOverviewStorage | null): string | null => {
    if (!storage) {
        return null;
    }

    return getInsuranceFromSails(storage);
};
